import { render, staticRenderFns } from "./FormularioOIRS.vue?vue&type=template&id=bf0a7c54&scoped=true&"
import script from "./FormularioOIRS.vue?vue&type=script&lang=ts&"
export * from "./FormularioOIRS.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioOIRS.vue?vue&type=style&index=0&id=bf0a7c54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0a7c54",
  null
  
)

export default component.exports